import {mapState, mapActions} from 'vuex'
// 游戏提示
const gameMaintain = {
  computed: {
    ...mapState({
      maintain_game_state: state => state.maintain_game_state,
      maintain_game_info: state => state.maintain_game_info
    })
  },
  watch: {
    maintain_game_state (state) {
      if (state) {
        this.openMaintainTip()
      }
    }
  },
  methods: {
    ...mapActions(['maintainGameState', 'maintainGameList']),
    openMaintainTip () {
      let self = this
      this.$alert(this.maintain_game_info, this.$t('common.tips'), {
        confirmButtonText:  this.$t('common.confirmButtonText'), 
        callback: () => {
          self.maintainGameState(false)
        }
      })
    }
  },
  mounted () {
    this.maintainGameList()
  }
}

export default gameMaintain



// WEBPACK FOOTER //
// ./src/common/mixins/game/game-maintain.js